import { createAction } from '@reduxjs/toolkit';

import { EditPropertyDetailsFormOutput } from '../../../components/CraftsmanEditPropertyDetailsModal/internal/types.ts';

export const submitEditPropertyDetailsForm = createAction<
  EditPropertyDetailsFormOutput & { id: string }
>('submitEditPropertyDetailsForm');
